import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const useAutotranslatePage = ({
  isLandingPage
}) => {
  const baseRequestPath = isLandingPage ? 'cospages/v2/landing-pages' : 'cospages/v2/site-pages';
  return ({
    primaryId,
    newVariationLanguage,
    contentGroupId,
    contentName,
    primaryLanguage
  }) => {
    const requestPayload = {
      language: newVariationLanguage,
      name: contentName,
      contentGroupId,
      autoCreateContentGroupLanguageVariation: true,
      masterLanguage: primaryLanguage
    };
    return http.post(`${baseRequestPath}/${primaryId}/translate`, {
      data: requestPayload
    }).then(({
      id,
      language,
      translatedFromId
    }) => ({
      objectId: id,
      portalId: PortalIdParser.get(),
      language,
      translatedFromId
    }));
  };
};
export default useAutotranslatePage;